import { defineStore } from 'pinia'
import * as Sentry from "@sentry/browser";
import router from '@/router'
import app from '@/main'

type consoleLogState = {
    logs: string[][];
    isEnabled: boolean;
    isSentryEnabled: boolean;
}

export const useConsoleLog = defineStore('consoleLog', {
    state: () : consoleLogState => ({
        logs: [],
        isEnabled: false,
        isSentryEnabled: false,
    }),
    persist: {
        enabled: false,
    },
    getters: {
        isLogEnabled(state) {
            return state.isEnabled
        },
        getIsSentryEnabled(state) {
            return state.isSentryEnabled
        }
    },
    actions: {
        appendLog(log: string, type: string) {
            const timeStamp = new Date()
            this.logs.push([timeStamp.toISOString() ,type, log])
        },
        enableLogging() {
            if (this.isEnabled) return;
            
            this.isEnabled = true
            const o_log = console.log
            console.log = (...args) => {
                this.appendLog(args.join(" "), "LOG")
                o_log(...args)
            }
            const w_log = console.warn
            console.warn = (...args) => {
                this.appendLog(args.join(" "), "WARNING")
                w_log(...args)
            }
            const e_log = console.error
            console.error = (...args) => {
                this.appendLog(args.join(" "), "ERROR")
               e_log(...args)
            }
            const i_log = console.info
            console.info = (...args) => {
                i_log(...args)
                this.appendLog(args.join(" "), "INFO")
            }
            const d_log = console.debug
            console.debug = (...args) => {
                d_log(...args)
                this.appendLog(args.join(" "), "DEBUG")
            }
        },
        clearLogs() {
            this.logs = []
        },
        enableSentry() {
            this.isSentryEnabled = true;
            if (!Sentry.isEnabled()) {
                Sentry.init({
                    app,
                    dsn: "https://7b62a63354fcc096fadd57ccd3547680@o4508154345422848.ingest.de.sentry.io/4508154416070736",
                    integrations: [
                        Sentry.browserTracingIntegration({router})
                    ],
                });
            }
        }
    },
})
